import SystemSpecs from "./SystemSpecs";

export default SystemSpecs;
